<div class="mb-4 flex bg-gray-100 rounded-2xl border p-4">
  <empro-icon
    [name]="'chevron-left'"
    [variant]="'secondary'"
    class="cursor-pointer mr-4"
    (click)="onCancelAction()"
    (keydown)="onCancelAction()"
  />

  <p>Neuen Kunden anlegen</p>
</div>
<iwt-estatecloud-common-customer
  [view]="CommonCustomerView.CREATE"
  (cancelAction)="onCancelAction()"
></iwt-estatecloud-common-customer>
